export default __webpack_public_path__ + "static/media/card-placeholder.90c3a878.jpg";